// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import PipRequiredItem from '@deere/cps-it.warranty-model-factory/lib/pip-required-item';
import {buildNumber} from '../../../shared/services/build-number';

function isTravel(key) {

    return (key === '05' || key === '06');

}

const OtherCreditDetails = props =>
    <li className='other-credit-item'>
        <FormattedMessage
            id='OTHER_CREDIT_ITEM_DETAILS'
            values={{
                description: props.item.description,
                quantity: isTravel(props.item.key) ? buildNumber(props.item.quantity) : buildNumber(props.item.amount),
                unit: isTravel(props.item.key) ? props.item.unit : props.item.currency
            }}
        />
    </li>;

OtherCreditDetails.displayName = 'LaborDetails';
OtherCreditDetails.propTypes = {
    item: PropTypes.instanceOf(PipRequiredItem).isRequired
};

export default OtherCreditDetails;



// WEBPACK FOOTER //
// ./src/pip/pip-details/components/other-credit-details.js